import { createFileRoute } from '@tanstack/react-router'
import { AgentTemplatesPage } from '@/features/agent-templates'

type CatalogSearch = {
  view?: 'templates' | 'packs'
}

export const Route = createFileRoute('/_authenticated/automation/templates/')({
  component: AgentTemplatesPage,
  validateSearch: (search: Record<string, unknown>): CatalogSearch => ({
    view:
      search.view === 'templates' || search.view === 'packs'
        ? search.view
        : undefined,
  }),
})
